import { render, staticRenderFns } from "./TutorSessionInvitePopUpComponent.vue?vue&type=template&id=1f56b09a&scoped=true&"
import script from "./TutorSessionInvitePopUpComponent.vue?vue&type=script&lang=js&"
export * from "./TutorSessionInvitePopUpComponent.vue?vue&type=script&lang=js&"
import style0 from "./TutorSessionInvitePopUpComponent.vue?vue&type=style&index=0&id=1f56b09a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f56b09a",
  null
  
)

export default component.exports